import Rule from '@elem/compPage/Rule';
import { useRouter } from 'next/router';
import IPRedirectLocal from 'eco-design-reliance/IPRedirect/IPRedirectLocal';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import { useLang } from '@/i18n';
import { redirectTo404 } from '@/utils';

const whiteLocaleList = ['us', 'ca', 'uk', 'au', 'za', 'eu', 'de', 'fr', 'it', 'es', 'jp', 'sa', 'cn', 'tw', 'kr', 'br', 'mx', 'ph', 'global'];
function Page({ SEO }: any) {
    const router = useRouter();
    const { t } = useLang('rule');

    return (
        <PageLayout theme="white">
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={router.locale} list={whiteLocaleList} pathname={'rule'} />
            <Rule />
            <IPRedirectLocal route="/data-security-and-privacy" />
        </PageLayout>
    );
}

export default Page;

export async function getServerSideProps({ locale }: any) {
    // 非白名单404；无站点前缀时 locale 为 en，由 withCountryRedirect 根据 IP 跳转
    if (locale !== 'en' && !whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
